"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBannersSaga = fetchBannersSaga;
exports.bannersProviderSaga = bannersProviderSaga;
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../LanguagesProvider/selectors");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/banners/api");
const slice_1 = require("./slice");
function* fetchBannersSaga() {
    try {
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data } = yield (0, effects_1.call)(api_1.getBanners, {
            locale,
        });
        yield (0, effects_1.put)(slice_1.bannersProviderActions.fetchBannersSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(`Error getting banners ${error}`);
        yield (0, effects_1.put)(slice_1.bannersProviderActions.fetchBannersError(error));
    }
}
function* bannersProviderSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeLatest)(slice_1.bannersProviderActions.fetchBanners, fetchBannersSaga)]);
}
//# sourceMappingURL=saga.js.map